import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout'
import RouterView from "@/components/RouterView";
import { getToken } from '@/utils/auth';

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',//登录页
    name: 'Login',
    component: () => import('@/views/login/login'),
  },
  {
    path: '/',//首页
    name: 'Home',
    redirect: '/home',
    component: Layout,
    children: [//子路由
      {
        path: '/home',//首页
        name: 'Home',
        component: () => import('@/views/home'),//指定组件
        meta: { title: '首页', permission: true }
      },
      {
        path: '/employeesManage',//员工管理
        name: 'EmployeesManage',
        component: () => import('@/views/accountManage/employeesManage'),//指定组件
        meta: { title: '员工管理', permission: true }
      },
      {
        path: '/labelManage',//标签管理
        name: 'LabelManage',
        component: () => import('@/views/accountManage/labelManage'),//指定组件
        meta: { title: '标签管理', permission: true }
      },
      {
        path: '/dataStatistics',//学习数据统计
        name: 'dataStatistics',
        component: () => import('@/views/accountManage/dataStatistics'),//学习数据统计
        meta: { title: '学习数据统计', permission: true }
      },
      {
        path: '/studentManage',//学员管理
        name: 'StudentManage',
        component: () => import('@/views/studentManage'),//指定组件
        meta: { title: '学员管理', permission: true }
      },
      {
        path: '/cardManage',//开卡管理
        name: 'CardManage',
        component: () => import('@/views/cardManage'),//开卡管理
        meta: { title: '开卡管理', permission: true }
      },
      {
        path: '/cardExportLog',//数据导出中心 
        name: 'CardExportLog',
        component: () => import('@/views/cardManage/cardExportLog'),//数据导出中心
        meta: { title: '数据导出中心', permission: true }
      },
      {
        path: '/callPhone',//呼叫平台
        name: 'callPhone',
        component: () => import('@/views/callPhoneManager'),//指定组件
        meta: { title: '呼叫平台', permission: true }
      },
      {
        path: '/taskList',//任务列表
        name: 'TaskList',
        component: () => import('@/views/callPhoneManager/taskList'),//退费申请
        meta: { title: '任务管理', permission: true }
      },
      {
        path: '/money',//外呼扣费管理
        name: 'money',
        component: () => import('@/views/callPhoneManager/money'),//指定组件
        meta: { title: '外呼扣费记录', permission: true }
      },
      {
        path: '/importDetalRecord',//导入详情记录
        name: 'importDetalRecord',
        component: () => import('@/views/callPhoneManager/importDetalRecord'),//指定组件
        meta: { title: '导入详情记录', permission: true }
      },
      {
        path: '/taskExecuteProfile',//任务执行概况
        name: 'taskExecuteProfile',
        component: () => import('@/views/callPhoneManager/taskExecuteProfile'),//指定组件
        meta: { title: '任务执行概况', permission: true }
      },
      {
        path: '/editTask',//编辑任务
        name: 'editTask',
        component: () => import('@/views/callPhoneManager/editTask'),//指定组件
        meta: { title: '编辑任务', permission: true }
      },
      {
        path: '/studentDetail',//学员已开商品
        name: 'StudentDetail',
        component: () => import('@/views/studentManage/detail.vue'),//已开商品
        meta: { title: '已开商品', permission: true }
      },
      {
        path: '/memberManage',//会员
        name: 'MemberManage',
        component: () => import('@/views/goodsManage/memberManage'),//指定组件
        meta: { title: '会员', permission: true }
      },
      {
        path: '/courseManage',//课程管理
        name: 'CourseManage',
        component: () => import('@/views/goodsManage/courseManage'),//指定组件
        meta: { title: '课程管理', permission: true }
      },
      {
        path: '/customOrderList',//定制资料
        name: 'CustomOrderList',
        component: () => import('@/views/goodsManage/customOrderList'),//指定组件
        meta: { title: '定制资料', permission: true }
      },
      // {
      //   path: '/customOrderList',//定制订单
      //   name: 'CustomOrderList',
      //   component: () => import('@/views/goodsManage/customOrderList'),
      //   meta: { title: '定制订单', permission: true }
      // }, 
      {
        path: '/customOrderAdd', 
        name: 'CustomOrderAdd',
        component: () => import('@/views/goodsManage/customOrderAdd'),// 定制资料添加 
        meta: { title: '定制资料添加',permission:true }
      }, 
      {
        path: '/customOrderFlowing', 
        name: 'CustomOrderFlowing',
        component: () => import('@/views/goodsManage/customOrderFlowing'),// 交易流水
        meta: { title: '交易流水',permission:true }
      }, 
      
      // {
      //   path: '/customOrderList',//定制订单
      //   name: 'CustomOrderList',
      //   component: () => import('@/views/goodsManage/customOrderList'),
      //   meta: { title: '定制订单', permission: true }
      // },


      {
        path: '/bktOtherGoods',//其它商品(备考工具资料)
        name: 'BktOtherGoods',
        component: () => import('@/views/goodsManage/bktOtherGoods'),//指定组件
        meta: { title: '其它商品', permission: true }
      },
      {
        path: '/setMealList',//套餐（仅对机构放开套餐商品）
        name: 'SetMealList',
        component: () => import('@/views/goodsManage/setMealList'),//套餐（仅对机构放开套餐商品）
        meta: { title: '套餐', permission: true }
      },
 
      {
        path: '/extendTool',//推广工具
        name: 'ExtendTool',
        component: () => import('@/views/extendManage/extendTool'),//推广工具
        meta: { title: '推广工具', permission: true }
      },


      {
        path: '/studentSelect',//从学员列表导入
        name: 'StudentSelect',
        component: () => import('@/views/goodsManage/studentSelect'),//指定组件
        meta: { title: '从学员列表导入', permission: true }
      },
      {
        path: '/importStudent',//查看已开通学员
        name: 'ImportStudent',
        component: () => import('@/views/goodsManage/importStudent'),//指定组件
        meta: { title: '查看已开通学员', permission: true }
      },
      {
        path: '/orderList',//订单列表
        name: 'OrderList',
        component: () => import('@/views/orderManage/orderList'),//指定组件
        meta: { title: '订单列表', permission: true }
      }, 
      {
        path: '/refundApplication',//退费申请
        name: 'RefundApplication',
        component: () => import('@/views/orderManage/refundApplication'),//退费申请
        meta: { title: '退费申请', permission: true }
      },
      {
        path: '/financialManage',//财务管理
        name: 'FinancialManage',
        component: () => import('@/views/financialManage'),//退费申请
        meta: { title: '财务管理', permission: true }
      },
      {
        path: '/recruitList',//营销工具
        name: 'RecruitList',
        component: () => import('@/views/recruitList'),//营销工具
        meta: { title: '营销工具', permission: true }
      },
      {
        path: '/institutionsOption',//设置
        name: 'InstitutionsOption',
        component: () => import('@/views/institutionsOption'),//退费申请
        meta: { title: '设置', permission: true }
      },
      {
        path: '/personalSettings',//个人设置
        name: 'PersonalSettings',
        component: () => import('@/views/personalSettings'),//退费申请
        meta: { title: '个人设置', permission: true }
      },
      {
        path: '/importRecord',//查看导入记录
        name: 'ImportRecord',
        component: () => import('@/views/importRecord'),//退费申请
        meta: { title: '查看导入记录', permission: true }
      },
      {
        path: '/importRecordDetail',//查看导入记录
        name: 'ImportRecordDeatail',
        component: () => import('@/views/importRecordDetail'),//退费申请
        meta: { title: '导入数据结果页', permission: true }
      },
      {
        path: '/userFeedback',//设置
        name: 'UserFeedback',
        component: () => import('@/views/userFeedback'),//退费申请
        meta: { title: '我要反馈', permission: true }
      },
      {
        path: '/statisticsData',
        name: 'StatisticsData',
        component: () => import('@/views/callPhoneManager/statisticsData'),//数据统计
        meta: { title: '数据统计', permission: true }
      },
      {
        path: '/extendTeachManage',
        name: 'extendTeachManage',
        component: () => import('@/views/recruitStudentManage/extendTeachManage'),//数据统计
        meta: { title: '推广老师管理', permission: true }
      },
      { 
        path: '/tobSettlement',
        name: 'tobSettlement',
        component: () => import('@/views/recruitStudentManage/tobSettlement'),//结算
        meta: { title: '结算', permission: true }
      },
      { 
        path: '/tobExperienceCard',
        name: 'tobExperienceCard',
        component: () => import('@/views/recruitStudentManage/tobExperienceCard'),//体验卡下载
        meta: { title: 'APP体验账号', permission: true } 
      },
      {
        path: '/tobFolderList',
        name: 'tobFolderList',
        component: () => import('@/views/recruitStudentManage/tobFolderList'),//宣传资料下载
        meta: { title: '宣传资料下载', permission: true }
      },
      {
        path: '/tobFileList',
        name: 'tobFileList',
        component: () => import('@/views/recruitStudentManage/tobFileList'),//文件列表
        meta: { title: '文件列表', permission: true }
      },
      {
        path: '/settlementProcess',
        name: 'settlementProcess',
        component: () => import('@/views/recruitStudentManage/settlementProcess'),//结算流程
        meta: { title: '结算流程', permission: true }
      },
      {
        path: '/recruitStudentTable',
        name: 'recruitStudentTable',
        component: () => import('@/views/recruitStudentManage/recruitStudentTable'),//数据统计
        meta: { title: '招生表单', permission: true }
      },
      {
        path: '/institutionalIncomeDetail', 
        name: 'institutionalIncomeDetail',
        component: () => import('@/views/recruitStudentManage/institutionalIncomeDetail'),// 机构收益明细
        meta: { title: '总收益明细',permission:true }
      },

      {
        path: '/noticeList', 
        name: 'noticeList',
        component: () => import('@/views/notice/noticeList'),// 公告列表
        meta: { title: '公告列表',permission:true }
      },
      {
        path: '/noticeDetail', 
        name: 'noticeDetail',
        component: () => import('@/views/notice/noticeDetail'),// 公告详情页
        meta: { title: '公告详情页',permission:true }
      },
      {
        path: '/operateVideo', 
        name: 'operateVideo',
        component: () => import('@/views/notice/operateVideo'),// 操作视频
        meta: { title: '操作视频',permission:true }
      },
      {
        path: '/helpManualList', 
        name: 'helpManualList',
        component: () => import('@/views/notice/helpManualList'),// 操作手册
        meta: { title: '操作手册',permission:true }
      }, 
      // {
      //   path: '/helpManualList', 
      //   name: 'helpManualList',
      //   component: () => import('@/views/notice/helpManualList'),// 帮助手册
      //   meta: { title: '帮助手册',permission:true }
      // },
      {
        path: '/helpManualInfo', 
        name: 'helpManualInfo',
        component: () => import('@/views/notice/helpManualInfo'),// 帮助手册_详情
        meta: { title: '帮助手册-详情',permission:true }
      },
      {
        path: '/appDownload', 
        name: 'appDownload',
        component: () => import('@/views/notice/appDownload'),// APP下载
        meta: { title: 'APP下载',permission:true }
      },
      // {
      //   path: '/studentProfile', 
      //   name: 'studentProfile',
      //   component: () => import('@/views/studentManage/studentProfile'),// 学员档案
      //   meta: { title: '学员档案',permission:true }
      // }, 
      {
        path: '/senioriupUserList', 
        name: 'senioriupUserList',
        component: () => import('@/views/studentManage/senioriupUserList'),// 考生档案
        meta: { title: '考生档案',permission:true }
      }, 
      {
        path: '/studentDetails', 
        name: 'studentDetails',
        component: () => import('@/views/studentManage/studentDetails'),// 学员详情
        meta: { title: '学员详情',permission:true }
      },

    ]
  }, 

  
]

// NavigationDuplicated: Avoided redundant navigation to current location 解决多次路由点击报错

// 获取原型对象push函数
const originalPush = VueRouter.prototype.push

// 获取原型对象replace函数
const originalReplace = VueRouter.prototype.replace

// 修改原型对象中的push函数
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

// 修改原型对象中的replace函数
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err)
}



const router = new VueRouter({
  routes
})


const whiteList = ['/login'];//白名单设置

// 全局路由守卫
router.beforeEach((to, from, next) => {
  // 没有token跳转完成登录
  const hasToken = getToken();

  if (hasToken) {
    if (to.path === '/login') {
      // 如果已经登录，还是访问的login页面，则自动跳转到主页
      next({
        path: '/home',
      });
    }
  } else {
    // 没有token
    if (whiteList.indexOf(to.path) !== -1) {
      //白名单则允许跳转
      next();
    } else {
      // 跳转登录
      next({
        path: '/login',
      });
    }
  }
  next();
})

export default router
